import subchapter1 from './subchapter1'
import subchapter2 from './subchapter2'

export const chapter1sub1 = subchapter1;
export const chapter1sub2 = subchapter2;